module.exports = new __parcel__URL__("kick.d3f59eaa.png").toString();